import React from 'react';

import { CorporateSubscriberCirclePartner } from '../../utils/backend-api/partners';
import { Button } from '../BaseUI';
import styles from './styles.module.scss';

interface CorporateSubscriberCircleCardProps {
  partner: CorporateSubscriberCirclePartner;
}

const CorporateSubscriberCircleCard = ({ partner }: CorporateSubscriberCircleCardProps) => {
  const { id, name, tagline, targetLink } = partner;
  return (
    <div className={styles.cscPartner}>
      <Button
        href={targetLink}
        variant="link"
        trackClick
        trackingProps={{
          name: 'csc_card',
          identifier: id.toString(),
        }}
      >
        {name}: {tagline}
      </Button>
    </div>
  );
};

export default CorporateSubscriberCircleCard;
